import { riskFireType } from 'store/typesActions/types';
import { api } from 'services/api';

export const riskFire = (code) => async (dispatch) => {
	dispatch({ type: riskFireType.RISK_FIRE });
	try {
		const res = await api.get(`/ti/${code}/risk_fire`);
		const { data } = res || {};
		dispatch({
			type: riskFireType.RISK_FIRE_SUCCESS,
			payload: data.risk
		});
		return data;
	} catch (error) {
		const { response } = error;
		if (response && response.statsu === 400) {
			const { message } = response.data;
			dispatch({
				type: riskFireType.RISK_FIRE_ERROR,
				payload: { errors: { message } }
			});
		} else {
			dispatch({
				type: riskFireType.RISK_FIRE_ERROR,
				payload: {
					errors: { message: 'Erro desconhecido. Tente novamente mais tarde' }
				}
			});
		}
	}
};
